/**
 * Customer Master — API client.
 *
 * Thin axios wrapper over `/api/customers/*`. Auth via the `token` query
 * parameter convention used everywhere else in the CRM.
 */
import axios from 'axios';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/customers`;
const unwrap = (res) => (res.data && 'data' in res.data ? res.data.data : res.data);

// ----- Duplicate check (gateway endpoint for all 3 lead-creation UIs) -----

export const checkDuplicate = (token, payload) =>
  axios.post(`${BASE}/check-duplicate`, payload, { params: { token } }).then(unwrap);

// ----- Customer Master CRUD -----

export const createCustomer = (token, payload) =>
  axios.post(BASE, payload, { params: { token } }).then((r) => ({
    data: unwrap(r),
    created: r.data?.created,
  }));

export const getCustomer = (token, customerId) =>
  axios.get(`${BASE}/${customerId}`, { params: { token } }).then(unwrap);

export const linkLeadToCustomer = (token, customerId, leadId, leadCollection) =>
  axios
    .post(
      `${BASE}/${customerId}/link-lead`,
      { lead_id: leadId, lead_collection: leadCollection },
      { params: { token } },
    )
    .then(unwrap);

export const getCustomerAuditLog = (token, customerId) =>
  axios.get(`${BASE}/${customerId}/audit-log`, { params: { token } }).then(unwrap);

// ----- Approval workflow (Options C + D) -----

export const submitDetailUpdateRequest = (token, payload) =>
  axios
    .post(`${BASE}/duplicate-requests/update`, payload, { params: { token } })
    .then(unwrap);

export const submitForceDuplicateRequest = (token, payload) =>
  axios
    .post(`${BASE}/duplicate-requests/force-duplicate`, payload, { params: { token } })
    .then(unwrap);

export const listDuplicateRequests = (token, status = 'pending') =>
  axios
    .get(`${BASE}/duplicate-requests`, { params: { token, status } })
    .then(unwrap);

export const approveDuplicateRequest = (token, requestId, reviewNotes = '') =>
  axios
    .post(
      `${BASE}/duplicate-requests/${requestId}/approve`,
      { review_notes: reviewNotes },
      { params: { token } },
    )
    .then(unwrap);

export const rejectDuplicateRequest = (token, requestId, reviewNotes = '') =>
  axios
    .post(
      `${BASE}/duplicate-requests/${requestId}/reject`,
      { review_notes: reviewNotes },
      { params: { token } },
    )
    .then(unwrap);

// ----- Admin dashboard metrics -----

export const fetchDuplicateDashboard = (token) =>
  axios.get(`${BASE}/dashboard/metrics`, { params: { token } }).then(unwrap);
